import { object } from 'valibot'

import { stringToNumber } from '@/libs/valibot'

export const customerParamsSchema = object({
  customerId: stringToNumber()
})
